import React from 'react'


const DisplayMenu = (props) =>
<svg {...props} viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg"><path d="M112 85H16c-5.514 0-10-4.486-10-10V17c0-5.514 4.486-10 10-10h96c5.514 0 10 4.486 10 10v58c0 5.514-4.486 10-10 10zM16 11c-3.309 0-6 2.691-6 6v58c0 3.309 2.691 6 6 6h96c3.309 0 6-2.691 6-6V17c0-3.309-2.691-6-6-6H16z"/><path d="M8 65h112v4H8zM77.831 112H50.169c-1.87 0-3.6-.849-4.745-2.328a5.96 5.96 0 0 1-1.063-5.178l5.704-21.996 3.871 1.004-5.703 21.996a1.991 1.991 0 0 0 .355 1.726c.381.493.958.776 1.581.776h27.662c.623 0 1.2-.283 1.581-.776a1.98 1.98 0 0 0 .354-1.726l-5.702-21.996 3.871-1.004 5.703 21.996a5.958 5.958 0 0 1-1.063 5.178A5.959 5.959 0 0 1 77.831 112z"/><circle cx="64" cy="75" r="2" /><path d="M64 79c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z" /></svg>

export default DisplayMenu


// WEBPACK FOOTER //
// ./src/components/_common/_icons/DisplayMenu.js